import {
    browserName,
    browserVersion,
    deviceType,
    getUA,
    osVersion,
    osName,
    mobileVendor,
    mobileModel,
    engineVersion,
    engineName,
    fullBrowserVersion,
    isFirefox,
} from "react-device-detect";
/**
 * Wrapper around the react-device-detect library selectors
 * NPM Page: https://www.npmjs.com/package/react-device-detect
 * Selectors: https://github.com/duskload/react-device-detect/blob/HEAD/docs/selectors.md
 */

const getUserAgent = (): string => {
    return getUA;
};

const getBrowserName = (): string => {
    return browserName;
};

const getBrowserMajorVersion = (): string => {
    return browserVersion;
};

const getBrowserFullVersion = (): string => {
    return fullBrowserVersion;
};

const getDeviceType = (): string => {
    return deviceType;
};

const getOSName = (): string => {
    return osName;
};

const getOSVersion = (): string => {
    return osVersion;
};

const getMobileVendor = (): string => {
    return mobileVendor;
};

const getMobileModel = (): string => {
    return mobileModel;
};

const getEngineName = (): string => {
    return engineName;
};

const getEngineVersion = (): string => {
    return engineVersion;
};

const isBrowserFirefox = (): boolean => {
    return isFirefox;
};

const isMobileWrapper = (): boolean => {
    const platform = getPlatform();
    return platform === "native_ios" || platform === "native_android";
};

const getPlatform = (): string => {
    // Check if running in a webview wrapper (native app)
    // The native app should set ZIGGY_PLATFORM to identify itself
    const ziggyPlatform = (window as any).__ZIGGY_PLATFORM__;
    if (ziggyPlatform) {
        return ziggyPlatform; // e.g., 'native_ios', 'native_android'
    }

    return "web";
};

const getAppVersion = (): string | undefined => {
    // Check if running in a webview wrapper (native app)
    // The native app should set ZIGGY_APP_VERSION to identify the app version
    return (window as any).__ZIGGY_APP_VERSION__;
};

export const DeviceUtil = {
    getUserAgent,
    getBrowserName,
    getBrowserMajorVersion,
    getBrowserFullVersion,
    getDeviceType,
    getOSName,
    getOSVersion,
    getMobileVendor,
    getMobileModel,
    getEngineName,
    getEngineVersion,
    isBrowserFirefox,
    isMobileWrapper,
    getPlatform,
    getAppVersion,
};
